import { useMemo } from 'react';
import { HCL_V2_FIND_PRODUCT_BY_PARTNUMBER_CAROUSEL } from '@/data/constants/product';
import { useProducts } from '@/data/Content/Products';
import { useContractByUserContext } from '@/utils/contractByUserContext';
import { DpIARecommendationResponse } from 'integration/generated/transactions/data-contracts';
import { useGetDpIARecommendation } from 'integration/hooks/useGetDpIARecommendation';
import { ProductType } from '@/data/types/Product';
import { useProductsWithInfoElectronico } from '@/data/Content/_Products_InfoElectronico';

export const useCatalogEntryIARecommendation = ({
	params,
	partNumbersExtractor,
	orderExtractor,
	filters,
}: {
	params: {
		partNumber?: string;
	};
	partNumbersExtractor: (data: DpIARecommendationResponse) => string[];
	orderExtractor?: (products: ProductType[], data: DpIARecommendationResponse) => ProductType[];
	filters?: Array<any>;
}) => {
	const { data: dpIARecommendation, isLoading: isLoadingDpIARecommendation } =
		useGetDpIARecommendation(params?.partNumber, filters);

	const partNumbers = useMemo(
		() => (dpIARecommendation ? partNumbersExtractor(dpIARecommendation) : []),
		[dpIARecommendation, partNumbersExtractor]
	);

	const contract = useContractByUserContext();

	const { products: rawProducts, loading: isLoadingProducts } = useProducts({
		partNumber: partNumbers,
		contractId: contract,
		query: { profileName: HCL_V2_FIND_PRODUCT_BY_PARTNUMBER_CAROUSEL },
	});

	const { data: productsWithInfoElectronico, isLoading: loadingInfoElectronicos } =
		useProductsWithInfoElectronico(rawProducts);

	const products = useMemo(
		() =>
			orderExtractor && dpIARecommendation
				? orderExtractor(productsWithInfoElectronico, dpIARecommendation)
				: productsWithInfoElectronico,
		[orderExtractor, productsWithInfoElectronico, dpIARecommendation]
	);

	return {
		isLoadingDpIARecommendation,
		isLoadingProducts: loadingInfoElectronicos || isLoadingProducts,
		dpIARecommendation,
		products,
		partNumbers,
		contract,
	};
};
